import { WarningIcon } from 'foundations-assets';
import { isOperatorAffectedByEmailHTML } from 'customer-data-filters-ui/utils/isAffectedByEmailHTML';
import EmailHTMLWarningDescription from './EmailHTMLWarningDescription';
import { View } from 'foundations-components/components/View';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
const EmailHTMLWarning = ({
  condition,
  use = 'warning'
}) => {
  const isAffectedByEmailHTML = condition && isOperatorAffectedByEmailHTML(condition);
  if (!isAffectedByEmailHTML) {
    return null;
  }
  if (use === 'warning') {
    return /*#__PURE__*/_jsx(View, {
      as: "div",
      marginBlockStart: "100",
      children: /*#__PURE__*/_jsx(EmailHTMLWarningDescription, {
        prefixIcon: /*#__PURE__*/_jsx(WarningIcon, {
          color: "fill-caution-default",
          size: "300"
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(Alert, {
    type: "warning",
    children: /*#__PURE__*/_jsx(EmailHTMLWarningDescription, {})
  });
};
export default EmailHTMLWarning;